import { Component } from '@angular/core';

@Component({
  template: `
    <div class="w-100 vh-100 d-flex justify-content-center pt-5">
      <p>
        You don't have the rights to access this portal.
      </p>
    </div>
  `,
})
export class SsoHandlerComponent {
}
